/* eslint-disable no-console */
export const renderTicks: (value: number) => number = (value) => {
  if (value === 0) {
    return 0;
  } else {
    return `${value}`.includes('.')
      ? value <= 1
        ? Number(value.toFixed(2))
        : Number((Math.round(value * 4) / 4).toFixed(0))
      : value <= 1
        ? value
        : Math.trunc(value);
  }
};

export const divideIntoSixParts = (total: number): number[] => {
  const parts = [];
  const increment = total / 5;
  if (total) {
    for (let i = 0; i <= 5; i++) {
      parts.push(renderTicks(i * increment));
    }
  }

  return parts;
};
